import { IntlProvider } from 'react-intl';
import { JSX } from 'react';

import enTranslations from  '../../../translations/en.json';
import uaTranslations from '../../../translations/ua.json';
import { AppTranslationProps } from './app-translations.models';
import { Locales } from '../../../constants/common-constants';
import { useLocale } from '../../../context';

export const AppTranslations = ({ children }: AppTranslationProps): JSX.Element => {
  const { locale } = useLocale();
  const translations = locale === Locales.en ? enTranslations : uaTranslations;

  return (
    <IntlProvider messages={translations} locale={locale} defaultLocale={Locales.ua}>
      {children}
    </IntlProvider>
  );
};
